import { Anchor, Breadcrumbs, Container, Stack } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router'
import { BoatForm } from '@/frontend/components/marina/BoatForm'
import { useCreateBoat } from '@/frontend/hooks/useBoats'
import { useCustomers } from '@/frontend/hooks/useCustomers'

export const Route = createFileRoute('/dashboard/accounts/boats/new')({
  component: NewBoat,
})

function NewBoat() {
  const navigate = useNavigate()
  const mutation = useCreateBoat()
  const { data } = useCustomers({ pageSize: 100 })
  const customers = data?.items ?? []

  return (
    <Container size="xl" py="md">
      <Stack gap="lg">
        <Breadcrumbs>
          <Anchor component={Link} to="/dashboard/accounts/boats" c="dimmed">
            Boats
          </Anchor>
          <span>New</span>
        </Breadcrumbs>

        <BoatForm
          customers={customers}
          submitLabel="Create Boat"
          submitting={mutation.isPending}
          onCancel={() => navigate({ to: '/dashboard/accounts/boats' })}
          onSubmit={async (values) => {
            try {
              const { boat } = await mutation.mutateAsync(values)
              notifications.show({
                title: 'Boat created',
                message: `${boat.name} added.`,
                color: 'teal',
              })
              navigate({ to: '/dashboard/accounts/boats' })
            } catch (e: unknown) {
              notifications.show({
                title: 'Failed to save',
                message: e instanceof Error ? e.message : 'Please try again',
                color: 'red',
              })
            }
          }}
        />
      </Stack>
    </Container>
  )
}
